import { useState } from "react"
import {ChevronDown} from 'lucide-react'

interface Course {
  title: string
  image: string
  hours: string
  lessons: string
  contents: string[]
  badge?: string
  badgeColor?: string
}

const courses: Course[] = [
  {
    title: "Nível Básico",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-NivelBrasico.webp",
    hours: "40 horas de aula",
    lessons: "64 aulas",
    contents: [
      "Como se apresentar corretamente",
      "Perguntar e responder informações pessoais como números, idade, telefone, e-mail e endereço",
      "Aprenderá sobre horas e nacionalidades",
      "Como fazer check-in e check-out em hotéis",
      "Principais informações e palavras para entrevista de emprego",
      "Rotinas do dia a dia",
      "Meses do ano e estações",
      "Lugares da cidade e como pedir informação",
      "Preposição de lugares e objetos de escritório",
      "Como fazer compras de alimentos",
      "Como conversar sobre dinheiro americano",
    ],
  },
  {
    title: "Nível Intermediário",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-NivelIntermediario.webp",
    hours: "45 horas de aula",
    lessons: "65 aulas",
    contents: [
      "Uso do verbo haver",
      "Uso do presente contínuo",
      "O presente contínuo usado para expressar o futuro",
      "Passado simples com verbos regulares e irregulares",
      "Used to",
      "O verbo haver no passado",
      "O passado contínuo",
      "Vocabulário e expressões de ambiente corporativo",
      "Atividades ao ar livre",
      "Características físicas e emocionais",
    ],
  },
  {
    title: "Nível Avançado",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-NivelAvancado.webp",
    hours: "35 horas de aula",
    lessons: "72 aulas",
    contents: [
      "Futuro em inglês",
      "Os verbos modais: can/could, may/might",
      "Passado com o present perfect",
      "Phrasal verbs com to get",
      "Present perfect continuous",
      "Voz passiva",
      "Os verbos modais: should/must/ought to/would/had better",
      "Past perfect continuous",
      "Use of wish",
      "Zero and first conditionals",
      "Second conditional",
    ],
  },
  {
    title: "Survival English",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa_SurvivalEnglish.webp",
    hours: "15 horas de aula",
    lessons: "29 aulas",
    contents: [
      "Apresentando-se em Inglês",
      "Como soletrar em inglês",
      "Os números em inglês / Uso de pronomes possessivos / Trocando informações pessoais",
      "Como dizer as horas em inglês / Regras do verbo To Be",
      "Como fazer check-in em um hotel / Dicas de viagem / Uso de pronomes de tratamento",
      "Dias da semana e meses do ano",
      "Como falar sobre hábitos e rotinas / Uso do presente simples",
      "Como chegar em alguns lugares da cidade",
      "Como fazer compras em inglês / Uso de \"How many\" e \"How much\" / Cores, vestuário, acessórios e tamanhos",
      "O Futuro Simples em inglês",
    ],
  },
  {
    title: "Inglês para Viagens",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-InglesParaVIagens.webp",
    hours: "15 horas de aula",
    lessons: "22 aulas",
    contents: [
      "Conceitos básicos sobre como aprender um idioma",
      "Como comprar uma passagem aérea, em inglês",
      "Arrumando as malas: tipos de bagagem em inglês",
      "Fazendo check-in e Cartão de embarque",
      "Embarcando: inglês na sala de embarque",
      "Inglês no avião",
      "Chegando ao seu destino: guichê de imigração e transporte para o local de hospedagem",
      "Inglês no hotel: fazendo check-in, inglês no quarto e fazendo check-out",
      "Inglês no restaurante: fazendo uma reserva por telefone, chegando no restaurante e fazendo o pedido",
      "Inglês fazendo compras: números, dinheiro e moedas pelo mundo e dentro da loja",
    ],
  },
  {
    title: "Inglês para Profissionais da Saúde — Módulo 1",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-InglesParaSaude-1.webp",
    hours: "30 horas de aula",
    lessons: "38 aulas",
    contents: [
      "Inglês básico para a área de saúde",
      "Inglês no hospital",
      "A anatomia humana",
      "Termos médicos informais",
      "Genética",
    ],
  },
  {
    title: "Inglês para Profissionais da Saúde — Módulo 2",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-InglesParaSaude-2.webp",
    hours: "30 horas de aula",
    lessons: "32 aulas",
    contents: [
      "Abordagem sistêmica da anatomia humana",
      "Histórico do paciente e exame físico",
      "Testes de imagem e laboratoriais",
      "Sinais e sintomas",
      "Doenças e problemas de saúde por sistemas",
    ],
  },
  {
    title: "Inglês para Área de TI",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-InglesParaTI.webp",
    hours: "15 horas de aula",
    lessons: "18 aulas",
    contents: [
      "Importância do inglês para a T.I.",
      "Redes e Comunicação",
      "Segurança Cibernética",
      "Desenvolvimento de Softwares",
      "Banco de Dados e Cloud",
      "Vocabulários IA",
      "Melhorando a pronúncia de alguns termos técnicos",
      "Dicas de comunicação profissional",
      "Dicas para Entrevistas Técnicas",
      "Tipos e Ferramentas para Documentação Técnica",
      "Metodologias e Documentação de Desenvolvimento de Projetos",
      "Desenvolvimento de projetos",
      "Teste e Qualidade",
      "Participando de Reuniões",
      "Dicas Finais",
    ],
  },
  {
    title: "Aulas de Fonética",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-AulasdeFonetica.webp",
    hours: "8 horas de aula",
    lessons: "8 aulas",
    contents: [
      "Palavras iguais com fonéticas diferentes",
      "Palavras com I e Y",
      "Palavras homófonas",
      "Palavras homógrafas",
      "Consoantes mudas",
      "Palavras Homônimas",
    ],
  },
  {
    title: "Aulas Adicionais — Nível Básico",
    image: "https://ewpass.com.br/wp-content/uploads/2025/03/Capa-AulasAdicionais-Basico.webp",
    hours: "20 horas de aula",
    lessons: "11 aulas",
    contents: [
      "PART-TIME and FULL-TIME jobs",
      "Possessive Pronouns",
      "Enthusiast Expressions",
      "Expressões do Cotidiano Corporativo",
      "Perguntas com \"WHO\"",
      "Uso do \"How often\" e Atividades físicas",
      "Fazendo o pedido em uma lanchonete",
      "Perguntas com \"Where\"",
      "Uso do \"at\", \"in\" e \"on\"",
      "Emprestar ou pegar emprestado?",
      "Os preços das coisas",
    ],
  },
  {
    title: "Aulões da EW Pass",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Quadrado-Auloes-EW-rg7j2swg5i0igzia98vgi4vxi92quvqdb2rc6lqcr4.png",
    hours: "34 horas de aula",
    lessons: "34 aulas",
    contents: [
      "Pronomes",
      "Presente Simples",
      "Presente Simples vs Presente Contínuo",
      "Simple Past",
      "Como ser fluente ainda este ano",
      "O futuro simples",
      "O presente perfeito",
      "Presente perfeito vs contínuo",
      "Voz Passiva",
      "O futuro contínuo",
      "O passado contínuo",
      "Coisas contáveis e não contáveis",
      "Verbos Modais",
      "Advérbios",
      "Jogos Gramaticais",
      "Discurso Indireto",
      "Fazendo deduções",
      "Expressões idiomáticas de inverno",
      "Expressando referências",
      "Os diferentes sons da letra \"U\"",
      "Palavras homógrafas",
      "Palavras homônimas",
      "Inglês com filmes e séries",
      "Inglês com músicas",
      "Inglês com memes (e redes sociais)",
      "Expressões idiomáticas de primavera",
      "Gírias em inglês",
      "Ler livros em inglês",
      "Dar e pedir direções",
      "Inglês para sua saúde",
      "Cargos e Profissões",
      "Dia de Ação de Graças",
      "Entrevistas de Emprego",
      "Retrospectiva do Ano",
    ],
  },
  {
    title: "Aulas Adicionais — Nível Intermediário",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Quadrado-Aulas-Adicionais-Intermediario-rg7j2swg5i0igzia98vgi4vxi92quvqdb2rc6lqcr4.png",
    hours: "8 horas",
    lessons: "10 aulas",
    contents: [
      "Describing home spaces",
      "Quantificadores",
      "Saying the years",
      "Fabrics and Materials",
      "Vocabulary of the Technological Universe",
      "Most Common Health Problems and Advice",
      "Feelings",
      "Emotions and Body language",
      "Describing People and Various Situations",
      "Questions about Characteristics of Something or Someone",
    ],
  },
  {
    title: "Aulas Adicionais — Avançado",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Quadrado-Aulas-Adicionais-Avancado-rg7j2r0rrtxxtrl0k827d5d0bhc0fhiwmtgd81t53k.png",
    hours: "12 horas de aula",
    lessons: "14 aulas",
    contents: [
      "ONE/ONES e Expressões úteis (Opiniões) para preço",
      "Would Prefer and Would Rather",
      "Questions with \"Who Can?\"",
      "Discurso Indireto",
      "Discurso Relatado",
      "Questions with \"HOW\"",
      "Supposed to and Expected to",
      "Cooking verbs",
      "Everyday problems + Get/Have something done",
      "By, around or until",
      "School subjects + Agreements",
      "Either ... or / Neither... nor",
      "Tag Questions",
      "Main Adverbs",
    ],
  },
  {
    title: "Inglês para Inteligência Artificial",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Quadrado-Ingles-para-IA-rg7j2us4gz5ak4w2y4kryo9fnuj3wzdltf3xxqggcw.png",
    hours: "4 horas de aula",
    lessons: "4 aulas",
    contents: [
      "Vocabulário de IA Generalista",
      "IA para Desenvolvedores",
      "IA para Área de Finanças",
      "IA para P.O.",
    ],
  },
  {
    title: "Inglês para Petróleo e Gás",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Quadrado-Ingles-para-Petroleo-rg7j2vpynt6kvqupsmzej60w98eh4ohc5jrff0f26o.png",
    hours: "10 horas de aula",
    lessons: "10 aulas",
    contents: [
      "Comece por aqui!",
      "Vocabulário essencial offshore",
      "Ferramentas e Equipamentos Comuns",
      "Comandos básicos e termos de segurança",
      "Máquinas, Perfuração e Processos Operacionais",
      "Estrutura da Embarcação e Operações Offshore",
      "Produção, Processamento e Transporte",
      "Instrumentação, Medição e Controle",
      "Segurança, Meio Ambiente e Situações de Emergência (HSE)",
      "Cargos, Profissões e Comunicação Técnica",
      "Vocabulário da Cozinha Embarcada",
      "Encerramento do curso",
    ],
  },
  {
    title: "Inglês para Mineração",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Capa-InglesParaMineracao-4-rlbwbjseloy0hg78421ubbl84g9dcqdfg1yr8kpgpc.png",
    hours: "13 horas de aula",
    lessons: "13 aulas",
    contents: [
      "Introdução",
      "Pessoas e Cargos",
      "Ferramentas e Equipamentos",
      "Materiais e Minerais",
      "Processos de Separação Física",
      "Métodos de Concentração e Separação",
      "Processos Químicos e Metalúrgicos",
      "Controle de Processos e Automação",
      "Controle de Qualidade e Análises Laboratoriais",
      "Produção e Movimentação de Materiais",
      "Segurança e Meio ambiente",
      "Pelotização e Queima",
      "Encerramento!",
    ],
  },
  {
    title: "Curso em Desenvolvimento",
    image: "https://ewpass.com.br/wp-content/uploads/elementor/thumbs/Capa-CursoEmDesenvolvimento-r52pyvzxjmza4wl28j03ui9pbnq5keiqum0gemby8g.webp",
    hours: "",
    lessons: "",
    badge: "Próximo Lançamento — Abril/26",
    badgeColor: "#B038B2",
    contents: [],
  },
]

function CourseCard({ course }: { course: Course }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
      </div>
      <div className="p-5">
        {course.badge ? (
          <div className="text-center mb-2">
            <span
              className="inline-block text-xs font-bold px-3 py-1 rounded-full text-white"
              style={{ backgroundColor: course.badgeColor }}
            >
              {course.badge}
            </span>
          </div>
        ) : (
          <div className="text-center mb-2">
            <p className="text-sm font-semibold text-gray-800">{course.hours}</p>
            <p className="text-sm text-gray-500">{course.lessons}</p>
          </div>
        )}

        {course.contents.length > 0 && (
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center gap-2 text-sm font-medium w-full pt-3 border-t border-gray-100 transition-colors"
            style={{ color: "#0E8EA0" }}
          >
            <ChevronDown
              size={16}
              className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`}
            />
            Conteúdo do curso
          </button>
        )}

        {open && course.contents.length > 0 && (
          <ul className="mt-3 space-y-1.5 animate-fade-in">
            {course.contents.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-600">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: "#0E8EA0" }} />
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default function CoursesSection() {
  return (
    <section className="py-20 bg-gray-50" id="cursos">
      <div className="max-w-6xl mx-auto px-5">
        <div className="text-center mb-14">
          <span
            className="inline-block text-sm font-bold tracking-widest uppercase mb-3"
            style={{ color: "#B038B2" }}
          >
            EW Academy
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Cursos Disponíveis
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-lg">
            Mais de 400 horas de conteúdo estruturado para você aprender inglês no seu ritmo, do básico ao avançado.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {courses.map((course) => (
            <CourseCard key={course.title} course={course} />
          ))}
        </div>
      </div>
    </section>
  )
}
